import { useState } from "react";
import PropTypes from "prop-types";
import { Button } from "@asosteam/asos-web-component-library-button";
import styles from "./styles";
import { useJoinStatus } from "../../context/join-status";
import {
  getCustomerTierId,
  setCustomerConsent,
} from "../../utilities/loyaltyUtils";
import { getAuthHeader } from "../../utilities/identityUtils";
import noticeError from "../../utilities/notice-error";
import {
  setErrorCode,
  setShowSuccess,
  setCurrentTierId,
} from "../../state/join-loyalty/reducer";
import { trackCTAInteraction } from "../../utilities/trackCTAInteraction";
import { getMyAccountUrl } from "../../helpers/getMyAccountUrl";
import { errorMessageKeys } from "../../helpers/getErrorMessage";

const analyticsProps = {
  pageName: "invited landing page",
  buttonType: "join now button",
};

const JoinNow = ({ isAnonymous, optedOutButtonText }) => {
  const [submitInProgress, setSubmitInProgress] = useState(false);
  const [, dispatch] = useJoinStatus();
  const handleSubmit = async () => {
    try {
      const authHeader = await getAuthHeader();
      if (authHeader) {
        await setCustomerConsent("OptedIn");
        const currentTierId = await getCustomerTierId();
        if (currentTierId) {
          dispatch(setCurrentTierId(currentTierId));
          return dispatch(setShowSuccess(true));
        } else {
          dispatch(setErrorCode(errorMessageKeys.optInError));
        }
      }
    } catch (e) {
      noticeError(e);
      const optInErrorCode = e?.response?.data[0]?.errorCode;
      dispatch(setErrorCode(optInErrorCode ? optInErrorCode : "optInError"));
    }
  };

  const onSubmit = async () => {
    trackCTAInteraction("loyalty-button-click", analyticsProps);
    setSubmitInProgress(true);
    await handleSubmit();
    setSubmitInProgress(false);
  };

  const onAnonymousSubmit = async () => {
    trackCTAInteraction("loyalty-button-click", analyticsProps);
    setSubmitInProgress(true);
    window.location.href = getMyAccountUrl("/my-account");
  };

  return (
    <Button
      onClick={isAnonymous ? onAnonymousSubmit : onSubmit}
      disabled={submitInProgress}
      isInProgress={submitInProgress}
      buttonType="primary-asos-world"
      className={styles.joinNowButton}
      size="default"
    >
      {optedOutButtonText}
    </Button>
  );
};

export default JoinNow;

JoinNow.propTypes = {
  isAnonymous: PropTypes.bool,
  optedOutButtonText: PropTypes.string,
};
